import { render } from "./OrgAreasOfExpertise.vue.js?vue&type=template&id=31f40a57!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgAreasOfExpertise.vue?vue&type=template&id=31f40a57"
import script from "./OrgAreasOfExpertise.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgAreasOfExpertise.vue?vue&type=script&lang=js"
export * from "./OrgAreasOfExpertise.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgAreasOfExpertise.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/OrgAreasOfExpertise.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31f40a57"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31f40a57', __exports__)) {
    api.reload('31f40a57', __exports__)
  }
  
  module.hot.accept("./OrgAreasOfExpertise.vue.js?vue&type=template&id=31f40a57!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgAreasOfExpertise.vue?vue&type=template&id=31f40a57", () => {
    api.rerender('31f40a57', render)
  })

}


export default __exports__